import React, { useContext, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import { useHistory } from 'react-router';

import clsx from 'clsx';
import styles from './style';
import Box from '../../../atomic/Box';
import Menu from '../../../atomic/Menu';
import Button from '../../../atomic/Button';
import MenuItem from '../../../atomic/MenuItem';
import Typography from '../../../atomic/Typography';
import AddIcon from '../../../../assets/icons/Add';
import RoomIcon from '../../../../assets/icons/DocumentBulkEditIcons/RoomIcon';
import EventIcon from '../../../../assets/icons/DocumentBulkEditIcons/EventIcon';
import ListItemIcon from '../../../atomic/ListItemIcon';
import ListItemText from '../../../atomic/ListItemText';
import useDashboardLinkPrefix from '../../../../hooks/useDashboardLinkPrefix';
import { FileUploadContext } from '../../../../contexts/fileUpload';
import { acSetShowAddRoom } from '../../../../store/actions/rooms';
import { acSetShowAddEvent } from '../../../../store/actions/events';
import SeparatorLine from '../../../atomic/SeparatorLine';
import { sGetActiveProperty } from '../../../../store/reducers/properties';
import { actionResetMDR } from '../../../../store/actions/mdr';
import DownloadOnDiscIcon from '../../../../assets/icons/DocumentBulkEditIcons/DownloadOnDiscIcon';
import matomo from '../../../../utils/matomo';

const AddButton = ({ classes, setShowAddRoom, setShowAddEvent, resetMDR }) => {
  const { onFileUploadClick } = useContext(FileUploadContext);
  const addButtonRef = useRef();
  const history = useHistory();
  const dashboardLinkPrefix = useDashboardLinkPrefix();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleClose = () => setIsMenuOpen(false);

  const onButtonClick = () => setIsMenuOpen(true);

  const onShowMissingDocumentsClick = () => {
    resetMDR();
    history.push(`${dashboardLinkPrefix}/create-mdr`);
    handleClose();
  };

  const onUploadDocumentClick = () => {
    matomo.clickEvent({
      category: 'Global',
      action: 'Upload Document from Add Button',
    });

    handleClose();
    onFileUploadClick({
      query: { bulkUploadMode: true, source: 'table', newUpload: true },
    });
  };

  const onRoomAddClick = () => {
    matomo.clickEvent({
      category: 'Global',
      action: 'Create New Room from Add Button',
    });

    handleClose();
    setShowAddRoom(true);
  };

  const onEventAddClick = () => {
    matomo.clickEvent({
      category: 'Global',
      action: 'Create New Event from Add Button',
    });

    handleClose();
    setShowAddEvent(true);
  };

  return (
    <>
      <Box py={3} pl={2} maxWidth={160} className={classes.addButtonWrapper}>
        <Button
          ref={addButtonRef}
          fullWidth
          disableElevation
          color="inherit"
          onClick={onButtonClick}
          className={classes.addButton}
        >
          <AddIcon className={classes.addIcon} fontSize="inherit" />
          <Typography className={classes.addButtonText} color="secondary">
            Legg til
          </Typography>
        </Button>
      </Box>

      <Menu
        PaperProps={{ className: classes.menu }}
        MenuListProps={{ className: classes.menuList }}
        keepMounted
        anchorEl={addButtonRef.current}
        onClose={handleClose}
        open={isMenuOpen}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <MenuItem
          className={classes.itemContainer}
          onClick={onUploadDocumentClick}
        >
          <ListItemIcon className={classes.itemIconContainer}>
            <AddIcon
              width={21}
              className={classes.itemIcon}
              fontSize="inherit"
            />
          </ListItemIcon>
          <ListItemText
            disableTypography
            className={clsx(classes.itemText, classes.itemTextBold)}
            primary="Last opp dokument"
          />
        </MenuItem>
        <SeparatorLine />
        <MenuItem className={classes.itemContainer} onClick={onRoomAddClick}>
          <ListItemIcon className={classes.itemIconContainer}>
            <RoomIcon width={20} height={20} className={classes.itemIcon} />
          </ListItemIcon>
          <ListItemText
            disableTypography
            className={classes.itemText}
            primary="Nytt rom"
          />
        </MenuItem>
        <MenuItem className={classes.itemContainer} onClick={onEventAddClick}>
          <ListItemIcon className={classes.itemIconContainer}>
            <EventIcon width={12} className={classes.itemIcon} />
          </ListItemIcon>
          <ListItemText
            disableTypography
            className={classes.itemText}
            primary="Ny hendelse"
          />
        </MenuItem>
        <SeparatorLine />
        <MenuItem
          className={classes.itemContainer}
          onClick={onShowMissingDocumentsClick}
        >
          <ListItemIcon className={classes.itemIconContainer}>
            <DownloadOnDiscIcon width={14} className={classes.itemIcon} />
          </ListItemIcon>
          <ListItemText
            disableTypography
            className={classes.itemText}
            primary="Etterspør dokumentasjon fra håndverker"
          />
        </MenuItem>
      </Menu>
    </>
  );
};

const mapStateToProps = (state) => ({
  activeProperty: sGetActiveProperty(state),
});

const mapDispatchToProps = (dispatch) => ({
  setShowAddRoom: (payload) => dispatch(acSetShowAddRoom(payload)),
  setShowAddEvent: (payload) => dispatch(acSetShowAddEvent(payload)),
  resetMDR: () => dispatch(actionResetMDR()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(AddButton));
